'use strict';
import * as $j_app$002eapi$002e$002dCreate$002dGeneral$002dPractice$002dRequest$0024$002dUser$002dData from "./app.api.-Create-General-Practice-Request$-User-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest$$anon$29(evaluator$20) {
  this.Lapp_api_CreateGeneralPracticeRequest$$anon$29__f_evaluator$10 = null;
  this.Lapp_api_CreateGeneralPracticeRequest$$anon$29__f_evaluator$10 = evaluator$20;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest$$anon$29 as $c_Lapp_api_CreateGeneralPracticeRequest$$anon$29 };
$c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest$$anon$29;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest$$anon$29() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest$$anon$29 as $h_Lapp_api_CreateGeneralPracticeRequest$$anon$29 };
$h_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype = $c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_CreateGeneralPracticeRequest$$anon$29__f_evaluator$10.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dCreate$002dGeneral$002dPractice$002dRequest$0024$002dUser$002dData.$c_Lapp_api_CreateGeneralPracticeRequest$UserData) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_CreateGeneralPracticeRequest$$anon$29.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_CreateGeneralPracticeRequest$$anon$29 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest$$anon$29, "app.api.CreateGeneralPracticeRequest$$anon$29", ({
  Lapp_api_CreateGeneralPracticeRequest$$anon$29: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest$$anon$29 as $d_Lapp_api_CreateGeneralPracticeRequest$$anon$29 };
//# sourceMappingURL=app.api.-Create-General-Practice-Request$$anon$29.js.map
